import React from "react";
import { createRoot } from "react-dom/client";
import * as serviceWorker from "./serviceWorkerRegistration";
import App from "./App";
const container = document.getElementById("root");
const root = createRoot(container!);

serviceWorker.unregister();

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Registrar el Service Worker
/*if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/serviceWorker.js")
      .then((registration) => {
        console.log("Service Worker registrado con éxito:", registration.scope);
      })
      .catch((error) => {
        console.log("Error al registrar el Service Worker:", error);
      });
  });
}*/
// Desregistrar cualquier Service Worker existente
if ("serviceWorker" in navigator) {
  navigator.serviceWorker.getRegistrations().then((registrations) => {
    for (let registration of registrations) {
      registration.unregister();
    }
  });
}
